import React, { memo } from "react";
import { XAxis, Tooltip, ResponsiveContainer, Line, LineChart, YAxis, Legend, CartesianGrid, Brush } from "recharts";

const CustomizedLegend = (props) => {
    if (props.payload.length) {
        return (
            <ul style={{ listStyle: 'none', display: 'flex', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>
                {
                    props.payload.map((entry, index) => (
                        <li key={`item-${index}`} style={{ display: 'flex', marginRight: '16px', alignItems: 'center' }}>
                            <span style={{ width: '16px', height: '8px', backgroundColor: `${entry.color}`, marginRight: '8px', borderRadius: '10px' }}>
                            </span>
                            <span>
                                {entry.dataKey}
                            </span>
                        </li>
                    ))
                }
            </ul>
        );
    } else {

        return " "
    }
}

const formatData = (data) => {
    let arr = [];

    if (data) {
        data.forEach((year) => {
            year.YearData.forEach((week) => {
                let weekObj = {};
                weekObj['week'] = `wk${week.WeekNo}-${year.Year}`
                weekObj['Baseline'] = parseFloat((week.Baseline)?.toFixed(0));
                weekObj['SecondarySale'] = parseFloat((week.SecondarySale)?.toFixed(0));
                arr.push(weekObj)
            })
        })
    }
    return arr;
}

const BaselineTimeLineChart = memo((props) => {
    let convertToArray = formatData(props.data);

    return (
        <ResponsiveContainer width={"100%"} height={"100%"}>
            <LineChart
                width={150}
                height={350}
                data={convertToArray}
                margin={{
                    top: 5,
                    right: 60,
                    left: 5,
                    bottom: 5,
                }}
            >
                <XAxis dataKey='week' axisLine={{ stroke: '#e6e6e7' }} style={{ fontSize: "12px" }} tickLine={false} />
                <YAxis interval={0} axisLine={{ stroke: '#e6e6e7' }} style={{ fontSize: "12px" }} tickLine={false} padding={{ top: 45 }} />
                <CartesianGrid vertical={false} />

                <Tooltip />
                <Brush stroke="#3f7fc9">
                    <LineChart data={convertToArray}>
                        <XAxis
                            dataKey="week"
                            padding={{ left: 0, right: 0 }}
                            axisLine={false}
                            tick={true}
                            tickLine={false}
                            tickSize={10}
                            fontSize={10}
                            domain={["dataMin", "dataMax "]}
                        />
                    </LineChart>
                </Brush>
                <Legend content={<CustomizedLegend external={props.data} />} height={'30px'} margin={{ top: 20 }} />

                <Line type="monotone" dataKey='Baseline' stroke='#219ebc' dot={false} strokeWidth={2} />
                <Line type="monotone" dataKey='SecondarySale' stroke='#63993d' dot={false} strokeWidth={2} />

            </LineChart>
        </ResponsiveContainer>

    );
}
)
export default BaselineTimeLineChart;